module.exports = __webpack_public_path__ + "img/banner2.5bd53da7.jpg";